"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

require("@pds/enterpriseFooter/enterpriseFooter.min");

var _excluded = ["className", "variant", "as", "lang", "addLoginHelp", "phoneNumber", "faxNumber", "contactUsUrl", "siteMapUrl", "customLoginHelpLink", "hideLinks", "showSocials", "legalText", "customSocialUrls", "customLinks"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// eslint-disable-next-line max-lines-per-function
var EnterpriseFooter = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var className = props.className,
      variant = props.variant,
      as = props.as,
      lang = props.lang,
      addLoginHelp = props.addLoginHelp,
      phoneNumber = props.phoneNumber,
      faxNumber = props.faxNumber,
      contactUsUrl = props.contactUsUrl,
      siteMapUrl = props.siteMapUrl,
      customLoginHelpLink = props.customLoginHelpLink,
      hideLinks = props.hideLinks,
      showSocials = props.showSocials,
      legalText = props.legalText,
      customSocialUrls = props.customSocialUrls,
      customLinks = props.customLinks,
      otherProps = _objectWithoutProperties(props, _excluded);

  var Component = as;
  var dataAttributes = {};

  if (hideLinks && hideLinks.length > 0) {
    hideLinks.forEach( // eslint-disable-next-line no-return-assign
    function (hideLink) {
      return dataAttributes["data-settings-".concat(hideLink)] = false;
    });
  }

  if (customSocialUrls && customSocialUrls.length > 0) {
    customSocialUrls.forEach( // eslint-disable-next-line no-return-assign
    function (customSocialUrl) {
      return dataAttributes["data-settings-".concat(customSocialUrl.social)] = customSocialUrl.socialUrl;
    });
  }

  var classes = (0, _classnames["default"])(className, {
    "pds-enterpriseFooter-dark": variant === "dark",
    "pds-enterpriseFooter-light": variant === "light"
  });
  return /*#__PURE__*/_react["default"].createElement(Component, _extends({
    "data-settings-legal-markup-option": legalText,
    "data-settings-social": showSocials,
    "data-settings-language": lang,
    "data-settings-login": addLoginHelp,
    "data-settings-login-help-link": customLoginHelpLink,
    "data-settings-phone-number": phoneNumber,
    "data-settings-fax-number": faxNumber,
    "data-settings-contact-us": contactUsUrl,
    "data-settings-site-map": siteMapUrl,
    "data-settings-custom-links": customLinks,
    ref: ref,
    className: classes
  }, otherProps, dataAttributes));
});

EnterpriseFooter.propTypes = {
  /** Additional classes  */
  className: _propTypes["default"].string,

  /** Changes the HTML element of the footer, for example "div" is used for super footer */
  as: _propTypes["default"].elementType,

  /** variant can either be dark or light  */
  variant: _propTypes["default"].oneOf(["dark", "light"]).isRequired,

  /** Languages supported  */
  lang: _propTypes["default"].oneOf(["es", "en"]),

  /** array to remove links  */
  hideLinks: _propTypes["default"].arrayOf(_propTypes["default"].oneOf(["terms-of-use", "disclosures", "privacy", "security", "report-fraud", "mobile-app", "espanol", "site-map"])),

  /** Social icons  */
  showSocials: _propTypes["default"].bool,

  /** Legal text option  */
  legalText: _propTypes["default"].oneOf(["pgi"]),

  /** Custom social URLs  */
  customSocialUrls: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    social: _propTypes["default"].oneOf(["facebook", "twitter", "linkedin", "youtube"]),
    socialUrl: _propTypes["default"].string
  })),

  /** Adds login help text and default helper link */
  addLoginHelp: _propTypes["default"].bool,

  /** Changes login helper link to custom one */
  customLoginHelpLink: _propTypes["default"].string,

  /** Changes login helper link to custom one */
  phoneNumber: _propTypes["default"].string,

  /** Changes login helper link to custom oe */
  faxNumber: _propTypes["default"].string,

  /** Changes login helper link to custom one */
  contactUsUrl: _propTypes["default"].string,

  /** Changes login helper link to custom one */
  siteMapUrl: _propTypes["default"].string,

  /** Extra custom links */
  customLinks: _propTypes["default"].string
};
EnterpriseFooter.defaultProps = {
  as: "footer"
};
EnterpriseFooter.displayName = "Footer";
var _default = EnterpriseFooter;
exports["default"] = _default;